import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { MatchParams } from "../types";
import { StaticContext } from "react-router";
import querystring from "query-string";
import { getResult } from "../../lib/api/subscriptions";
import Results, { ResultsProps } from "./Result";
import useSubscriptionResults from "../../hooks/useSubscriptionResults";

type locationState = {
  status: string;
  listName: string;
  resultMsg: string;
  modifyUrl: string;
  paymentUrl: string;
  subscriptionUrl: string;
};

type parsedQueryString = {
  token?: string;
};

function SubscribeResult(props: RouteComponentProps<MatchParams, StaticContext, locationState>) {
  
  const { location, history, match, staticContext } = props;

  const qs: parsedQueryString = querystring.parse(window.location.search);

  const { getSubscriptionsResults, subscriptionsResults } = useSubscriptionResults()

  //state가 있는 경우 => 구독확인메일 x

  //state가 없는 경우 => 구독확인메일 o
  
  useEffect(()=>{
    if (qs.token) {
      getSubscriptionsResults({listId:match.params.listId, token:qs.token})
    }
  },[])

  const result = () => {
    //구독폼에서 바로 넘어온 경우 결과 페이지
    if (location.state) {
      return (
        <Results
          status={location.state.status}
          listName={location.state.listName}
          resultMsg={location.state.resultMsg}
          modifyUrl={location.state.modifyUrl}
          paymentUrl={location.state.paymentUrl}
          subscriptionUrl={location.state.subscriptionUrl}
        />
      );

    //구독 확인 이메일 링크 클릭 시
    }else if(qs.token){
      //emailAddress: "jihyun+46@stibee.com"
      // listId: 801
      // listName: "\"스티비\"과 함께하는 뉴스레터<스티비>"
      // modifyUrl: "/subscribers/auth/801?email=jihyun+46@stibee.com"
      // status: "ok"
      //success
      if(subscriptionsResults.status === 'request'){
        //로딩 중
        return(<></>)
      }else if(subscriptionsResults.status === 'success'){
        // return(
        //   <Results status={'NonConfirm'} listName={subscriptionsResults.data.listName} resultMsg={'구독해주셔서 감사합니다.'} modifyUrl={subscriptionsResults.data.modifyUrl}/>
        // )
        if(subscriptionsResults.data.status ==='nonConfirm'){
          return(
            <Results status={'NonConfirm'} listName={subscriptionsResults.data.listName} resultMsg={'구독해주셔서 감사합니다.'} modifyUrl={subscriptionsResults.data.modifyUrl}/>
          )

          //간편결제 시에만 작동, 결제정보 등록 후 redirect되는 상황
        }else if(subscriptionsResults.data.status === 'confirm'){
          return(
            <Results status={'Confirm'} listName={subscriptionsResults.data.listName} resultMsg={`입력하신 이메일 주소(${subscriptionsResults.data.emailAddress})로 확인 메일을 보내드렸습니다.`}/>
          )
        }
        
      }else if(subscriptionsResults.status === 'failure'){
        //error
        if(subscriptionsResults.errorData?.response?.data?.error?.Code === 'Errors.List.ExpiredToken'){
          return(
            <Results
              listName={subscriptionsResults.errorData?.response?.data.listName}
              resultMsg={'이미 만료된 구독 확인 링크입니다.'}
              subscriptionUrl={`/subscriptions/${match.params.listId}`}
            />
          )
        }else if(subscriptionsResults.errorData?.response?.data?.error?.Code === 'Errors.Payment.FailedToPay'
          || subscriptionsResults.errorData?.response?.data?.error?.Code === 'Errors.List.NotExistList'
        ){
          return(
            <Results
              listName={subscriptionsResults.errorData?.response?.data.listName}
              resultMsg={'결제에 실패하여 구독 신청이 완료되지 않았습니다.\r\n결제 정보를 다시 입력하여 결제를 다시 시도하세요.'}
              subscriptionUrl={ `/subscriptions/${match.params.listId}`}
            />
          )
        }
      }
    }
    return (
      <Results
        resultMsg={'잘못된 접근입니다.'}
      />
    )
  };


  return result();
}

export default SubscribeResult;
